var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"lbHotelResultsCardItem_rating rating-stars {{ 'rating-' + vm.stars }}\" ng-class=\"{ half: vm.isDecimal }\" ng-attr-title=\"{{::vm.rating}} out of 5\">\n<i class=\"ico-star star1\"></i>\n<i class=\"ico-star star2\"></i>\n<i class=\"ico-star star3\"></i>\n<i class=\"ico-star star4\"></i>\n<i class=\"ico-star star5\"></i>\n</div>\n";
var id1="components/lbFiveStarRating/lbFiveStarRatingTemplate.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbFiveStarRating/lbFiveStarRatingTemplate.html
// module id = 1198
// module chunks = 1